<template lang="pug">
div
  v-app-bar.primary.elevation-2(fixed, app)
    router-link.h-100.white--text.pa-1(to="/")
      img.logo(:src="logo", contain, height="100%")
    v-spacer
    v-app-bar-nav-icon(color="white", @click="drawer = !drawer")
  v-navigation-drawer.primary(v-model="drawer", fixed, temporary)
    router-link.white--text.h-100(to="/")
      img.logo.mx-8.mt-4(:src="logo", contain)
      .d-flex.flex-column.align-center
    v-divider.primary.darken-1
    v-list-item-group(v-model="current")
      v-list(dense, nav, dark)
        template(v-for="(route, i) in menu")
          v-list-item(v-if="!route.dropdown", :key="i", :to="route.path", link)
            v-list-item-icon(v-if="route.icon")
              v-icon {{ route.icon }}
            v-list-item-content
              v-list-item-title.body-2 {{ route.name }}
          v-list-group(
            v-else,
            :key="i",
            :prepend-icon="route.icon",
            no-action,
            color="white"
          )
            template(#activator)
              v-list-item-title.body-2(@click="() => $router.push(route.path)") {{ route.name }}
            v-list-item.pl-6(
              v-for="(r, i) in route.dropdown",
              :key="i",
              :to="r.path",
              link,
              exact
            )
              v-list-item-content
                v-list-item-title.body-2 {{ r.name }}
</template>

<script>
import { getWhatsappLinkFromPhone } from "@/components/utils";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
    whatsappLink() {
      return getWhatsappLinkFromPhone(
        this.$rest("informations").item.whatsapp || ""
      );
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
};
</script>

<style>
.v-navigation-drawer__content .logo {
  height: 40px;
}
.v-navigation-drawer {
  z-index: 9999 !important;
}
</style>
